var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSkipBack = function SvgSkipBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.701 26.665c.868 0 1.577-.78 1.577-1.73v-8.383c.114.356.341.691.68.969l10.592 8.666c1.022.836 1.86.44 1.86-.882V6.695c0-1.321-.837-1.72-1.86-.882L12.959 14.48a2.1 2.1 0 0 0-.681.969V7.064c0-.95-.71-1.73-1.577-1.73H8.167c-.867 0-1.577.78-1.577 1.73v17.871c0 .95.71 1.73 1.577 1.73h2.535Z",
    clipRule: "evenodd"
  })));
};
export default SvgSkipBack;